<template>
	<div id="centerWidth" style="overflow: auto;height: calc(100vh - 140px);margin-top: 10px;">
		<div class="centerWidth">
			<div class="gaokao">
				<div class="gaokao-nav">
					<span @click="goMyCenter">个人中心 ></span>
					<span>查:专业查询</span>
				</div>

				<section class="gaokao-content">
					<div class="my-title">专业查询</div>

					<div class="chaBg">
						<div class="major-share-con" id="TK">
							<div class="share-li">
								<p style="min-width: auto;">搜索专业:</p>
								<input placeholder="请输入专业名称" v-model="name" />
							</div>
							<div class="major-btn01"><button class="gaokao-btn" @click="GetShareName()">搜索</button>
							</div>
						</div>
						<p v-for="(item, index) in list" :key="index" :class="isTab == index ? 'on' : ''"
							@click="tabClick(index)">
							<a>{{ item.Name }}</a>
						</p>
					</div>

					<section class="chaList">
						<ul>
							<li v-for="(item, index) in list" :key="index">
								<h6 :id="'T' + index" v-html="item.HtmlName || item.Name"></h6>
								<dl>
									<dd v-for="(child, index2) in item.Children" :key="index2">
										<h5>
											<span>•</span>
											<span :id="'S' +index+ '_'+index2" v-html="child.HtmlName || child.Name"></span>
										</h5>
										<hgroup>
											<p class="fwbhtml" v-for="(three, index3) in child.Children" :key="index3"
												@click="details(three.Id)" :id="'D'+index+ '_'+index2+'_'+index3"
												v-html="three.HtmlName || three.Name"></p>
										</hgroup>
									</dd>
								</dl>
							</li>
						</ul>
					</section>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				name: '',
				isTab: -1,
				list: []
			};
		},

		// 加载
		created() {
			if (this.$route.query.key) {
				this.$api.reduceUserCount({
					key: this.$route.query.key
				});
			} else {
				this.$router.back(-1);
			}
			this.GetNewProfessionalType();
		},
		watch: {
		},
		mounted() {
		},
		methods: {
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},
			transformName(name) {
				if (this.name) {
					return name.replace(new RegExp('(' + this.name + ')', 'ig'), '<strong style="color: red;">' + this.name + '</strong>');
				} else {
					return name;
				}
			},
			GetShareName() {
				this.list = [].concat(this.list);
				let firstHitId;
				for (const item1 of this.list) {
					let i1 = this.list.indexOf(item1);
					item1.HtmlName = this.transformName(item1.Name);
					firstHitId = firstHitId || (item1.Name != item1.HtmlName ? 'T' + i1 : undefined);
					for (const item2 of item1.Children) {
						let i2 = item1.Children.indexOf(item2);
						item2.HtmlName = this.transformName(item2.Name);
						firstHitId = firstHitId || (item2.Name != item2.HtmlName ? 'S' + i1 + '_' + i2 : undefined);
						for (const item3 of item2.Children) {
							let i3 = item2.Children.indexOf(item3);
							item3.HtmlName = this.transformName(item3.Name);
							firstHitId = firstHitId || (item3.Name != item3.HtmlName ? 'D' + i1 + '_' + i2 + '_' + i3 : undefined);
						}
					}
				}
				if (firstHitId) {
					document.querySelector('#' + firstHitId).scrollIntoView(true);
				} else {
					document.querySelector('#TK').scrollIntoView(true);
				}
			},
			GetNewProfessionalType() {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/NewProfessionalType',
					'GET', {},
					function(res) {
						console.log('获取列表',res);
						if (res.flag) {
							that.list = res.list;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			tabClick(ixd) {
				this.isTab = ixd;
				document.querySelector('#T' + ixd).scrollIntoView(true);
			},
			details(tid) {
				// this.$router.push({
				// 	path: '/majorDetails',
				// 	query: {
				// 		tid: tid
				// 	}
				// });
				var routeUrl = this.$router.resolve({
					path: '/majorinfo',
					query: {
						Id: tid
					}
				});
				window.open(routeUrl.href, '_blank');
			}
		}
	};
</script>

<style scoped>
	.gaokao-btn {
		width: 90px;
		font-size: 14px;
		margin-left: 0 !important;
	}

	.major-share-con {
		width: 75%;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 20px;
	}

	.share-li {
		width: 50%;
		display: flex;
		align-items: center;
		/* justify-content: center; */
		margin: 0 0 10px 0;
	}

	.share-li p {
		font-size: 14px;
		color: #333;
		width: 100px;
		text-align: right;
		margin-right: 20px;
	}

	.share-li input {
		width: 270px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: block;
		border-radius: 5px;
		background-color: #fff;
		color: #333;
		font-size: 14px;
	}

	.share-li input::-webkit-input-placeholder {
		color: #999;
	}

	.share-li input:-moz-placeholder {
		color: #999;
	}

	.share-li input:-ms-input-placeholder {
		color: #999;
	}

	.sjWidth {
		width: 270px;
	}

	.major-btn01 {
		width: 25%;
	}

	.chaList dd hgroup p {
		font-size: 14px;
		color: #333;
		margin-top: 20px;
		position: relative;
		padding-right: 30px;
		margin-right: 30px;
		display: inline-block;
		cursor: pointer;
	}

	.chaList dd hgroup p::after {
		content: '';
		width: 1px;
		height: 14px;
		background-color: #e6e6e6;
		position: absolute;
		right: 0;
		top: 50%;
		margin-top: -7px;
		z-index: 1;
	}

	.chaList dd hgroup p:last-child::after {
		width: 0;
	}

	.chaList dd hgroup p:hover {
		opacity: 0.7;
	}

	.chaList dd h5 span {
		margin-right: 10px;
	}

	.chaList dd h5 {
		font-weight: normal;
		font-size: 14px;
		height: 60px;
		border-bottom: solid 1px #e6e6e6;
		line-height: 60px;
	}

	.chaList dd {
		margin-top: 20px;
	}

	.chaList h6 span {
		font-size: 14px;
		color: #333;
		font-weight: normal;
		margin-left: 1em;
	}

	.chaList h6 {
		font-size: 16px;
		color: #333;
		background-color: #eaeaea;
		position: relative;
		padding-left: 20px;
		height: 50px;
		line-height: 50px;
	}

	.chaList h6::after {
		content: '';
		width: 4px;
		height: 100%;
		background-color: #333;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 2;
	}

	.chaList li {
		margin-top: 30px;
	}

	.chaList {
		margin-bottom: 20px;
	}

	.chaBg p.on {
		background-color: #333;
		color: #fff;
	}

	.chaBg p.on a {
		color: #fff;
	}

	.chaBg p {
		font-size: 14px;
		color: #333;
		cursor: pointer;
		display: inline-block;
		background-color: transparent;
		border-radius: 4px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		min-width: 50px;
		padding: 0 10px;
		margin-right: 20px;
	}

	.chaBg p a {
		font-size: 14px;
		color: #333;
		width: 100%;
		text-align: center;
		display: block;
	}

	.chaBg {
		overflow: hidden;
		background-color: #eaeaea;
		padding: 40px;
		margin: 20px 0;
	}

	/* chaBg */

	.gaokao {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}
</style>
